import { render, staticRenderFns } from "./SideBarBooking.vue?vue&type=template&id=32a85226"
import script from "./SideBarBooking.vue?vue&type=script&lang=js"
export * from "./SideBarBooking.vue?vue&type=script&lang=js"
import style0 from "./SideBarBooking.vue?vue&type=style&index=0&id=32a85226&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports